export const visitorsCards = {
  sessionsDuration: 'sessionsDuration',
  userSessions: 'userSessions',
  bounceRate: 'bounceRate',
  averagePagesPerSession: 'averagePagesPerSession',
};

export const AVERAGE_PAGES_PER_SESSION_FILE_NAME = 'average-pages-per-session';
export const AVERAGE_SESSIONS_PER_VISITOR_FILE_NAME = 'average-sessions-per-visitor';
export const AVERAGE_SESSION_DURATION_FILE_NAME = 'average-session-duration';
export const AVERAGE_ACTIVE_VIEWPORT_TIME_FILE_NAME = 'average-active-viewport-time-per-session';
